'use strict';

const element = require('./element');
const userDetails = require('./userDetails');
const utils = require('../utils/utils');

function create(data, notificationBaeUrl, ts) {
  const locale = data.locale;
  const language = data.language;
  element.cssTag(`${notificationBaeUrl}assets/cookie-notification.css`);
  const bannerWrapper = element.create('div', 'cookieNotificationBannerWrapper');
  const notificationText = element.create('p', 'cookieNotificationText');

  notificationText.innerHTML = locale['notification.message'];

  const moreInfo = element.create('a', 'cookieNotificationMoreInfo');
  moreInfo.text = locale['notification.more.info'];
  moreInfo.href = `http://${language === 'en' ? 'www' : language}.wix.com/about/privacy`;
  moreInfo.target = '_blank';
  moreInfo.addEventListener('click', () => {
    utils.reportBI('513');
  });

  const gotIt = element.create('a', 'cookieNotificationGotIt');
  gotIt.text = locale['notification.got.it'];
  gotIt.addEventListener('click', () => {
    utils.reportBI('512');
    userDetails.setToLocalStorage('wixCookieNotification', 'approved');
    element.remove('cookieNotificationBannerWrapper');

  });

  const arrow = element.create('img', 'cookieNotificationArrow');
  arrow.src = `${notificationBaeUrl}assets/arrow1.svg`;

  element.append(element.bodyTag(), bannerWrapper);
  element.append(bannerWrapper, notificationText);

  element.append(gotIt, arrow);

  element.append(notificationText, moreInfo);
  element.append(notificationText, gotIt);
  utils.reportBI('511', [`delta=${new Date().getTime() - ts}`]);

}

export {create};



// WEBPACK FOOTER //
// ./modules/visual.js